module.exports = __webpack_public_path__ + "media/images/bg/shapes/ecru/1-b2920ebc8135f2683fc421f88b63f950.svg";